var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments"},[_c('div',{staticClass:"col"},[_c('ReComment')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }